import helpers from '../../helpers'
import { listDrugs, protocolDrugs } from '../../api/balance'

export default {
  'entityName': 'patch_has_drug',
  'title': 'Patch drug',
  id: ['id'],
  'pagination': {
    'rowsPerPage': 10,
    'page': 1,
    'sortBy': 'drug_id',
    'descending': true
  },
  'fields': [
    {
      value: 'operation',
      small: true,
      list: ['GET','PUT'],
      type: 'list',
      text: 'Operation',
      validators: ['required'],
      table: true
    },    
    {
      small: true,
      value: 'place',
      type: 'list',
      text: 'Place',
      list: ['SITE', 'STORAGE'],
      validators: ['required'],
      table: true
    },
    {
      "value": "site_id",
      "text": "Site",
      small: true,
      reference: 'protocol_has_site',
      id: 'site_id',
      deps: ['place'],
      type: 'autocomplete',
      default: () => null,
      render: item => item.site_id ? `${item.site.name} - ${item.site.code}` : item?.storage?.name,
      title: 'site.name',
      subtitle: ({ site }) => `${site.city} - ${site.code}`,
      filter: (item, search) => {
        const filters = { protocol_id: item.protocol_id }
        if (search) {
            filters['site.name'] = [{ 'site.city': `%${search}%` }, {'site.name': `%${search}%`}, { 'site.code': `%${search}%`}]
        }
        return filters
      },
      table: {
          sortable: true,
          filter: true
      },
      validators: ['required'],
      readonly: item => !item.place,
      visible: item => item.place === 'SITE' || !item.place
      
    },
    {
      value: 'storage_id',
      small: true,
      reference: 'drug',
      id: 'storage.id',
      filter: (item) => ({ storage_id: '!=null', always_available: 0, protocol_id: item.protocol_id }),
      deps: ['place'],
      default: () => null,
      title: 'storage.name',
      subtitle: 'city',
      text: 'Storage',
      validators: ['required'],
      type: 'autocomplete',
      visible: item => item.place === 'STORAGE'
    },
    {
      'value': 'drug_id',
      'text': 'Drug',
      id: 'drug_id',
      deps: ['site_id', 'place', 'storage_id', 'operation'],
      list: (entity, search, item) => item.operation === 'GET' ? listDrugs(entity, search, item) : protocolDrugs(entity, search, item),
      'type': 'autocomplete',
      'title': 'drug.name',
      filter: item => ({ protocol_id: item.protocol_id }),
      subtitle: ({ drug }) => drug.packaging + (drug.packaging !== 'Labels' ? ` (${drug.dose}${drug.measure_unit})` : ''),
      table: true,
      render: ({drug}) => drug && `${drug.name} (${drug.packaging}, ${drug.dose}${drug.measure_unit})`,
      small: true,
      readonly: item => !item.place || ((item.place === 'SITE' && !item.site_id) || (item.place === 'STORAGE' && !item.storage_id)),
      validators: [
        'required'
      ],
    },
    {
      value: '_packaging',
      deps: ['drug_id'],
      visible: false,
      default: (item, args, selected) => selected && selected.drug.packaging
    },
    {
      value: '_put_lotto',
      text: 'Batch number',
      title: 'lotto',
      subtitle: item => `${item.n_pieces} / ${item.expiration}`,
      render: item => item.lotto,
      list: listDrugs,
      // table: true,
      id: 'lotto',
      default: () => null,
      deps: ['drug_id', 'operation', 'place', 'site_id', 'storage_id'],
      type: 'combobox',
      readonly: item => !item.drug_id,
      small: true,
      visible: item => item._packaging !== 'Labels' && item.operation === 'PUT' ,
      validators: ['required', 'nowhitespace']
    },
    {
      'value': '_serials_available',
      type: 'hidden',
      visible: false,
      deps: ['drug_id'],
      default: (item, args, selected) => selected && selected.drug.serials_available
    },    
    {
      value: '_get_lotto',
      text: 'Batch number',
      title: 'lotto',
      default: () => null,
      subtitle: item => `${item.n_pieces} / ${item.expiration}`,
      render: item => item.lotto,
      list: listDrugs,
      // table: true,
      id: 'lotto',
      deps: ['drug_id', 'operation', 'place', 'site_id', 'storage_id'],
      type: 'autocomplete',
      readonly: item => !item.drug_id,
      small: true,
      visible: item => item._packaging !== 'Labels' && (item.operation === 'GET' || !item.operation),
      validators: ['required', 'nowhitespace']
    },    
    {
      value: 'lotto',
      text: 'Batch number',
      table: true,
      deps: ['_put_lotto', '_get_lotto'],
      default: item => item._get_lotto ?? item._put_lotto,
      type: 'hidden',
      hidden: true
    },
    {
      value: '_has_expiration',
      type: 'hidden',
      deps: ['lotto'],
      default: (item, args, selected) => !!(selected && item.lotto && selected.expiration)
    },
    {
      value: 'expiration',
      type: 'datetime',
      small: true,
      text: 'Expiration',
      table: true,
      readonly: item => !item.drug_id || !item.lotto || item.operation !== 'PUT' || item._has_expiration,
      deps: ['lotto', '_packaging'],
      validators: ['required'],
      visible: item => item._packaging !== 'Labels',
      default: (item, args, selected) => selected && item.lotto && selected.expiration
    },
    {
      value: '_n_available_pieces',
      deps: ['lotto'],
      default: (item, args, selected) => selected && selected.n_pieces,
      visible: false
    },
    {
      small: true,
      value: 'n_pieces',
      text: 'Quantity',
      deps: ['lotto', 'serials'],
      table: true,
      default: (item) => (item.serials && helpers.nSerials(item.serials) || 0),
      readonly: item => !!item._serials_available,
      'validators': [
        'required',
        'number',
        (field, value, item) => (item.operation === 'PUT' || value <= item._n_available_pieces) || `Should be <= of available pieces (${item.n_pieces} > ${item._n_available_pieces})`,
      ]
    },
    {
      full: true,
      "value": "_original_serials",
      text: 'Available Serials',
      deps: ['lotto', 'drug_id'],
      default: (item, args, selected) => selected && selected.serials,
      visible: item => item._serials_available && item.lotto,
      readonly: true
    },
    {
      value: '_serials',
      full: true,
      text: 'Serials',
      type: 'textarea',
      deps: ['lotto', 'drug_id', '_original_serials'],
      default: item => item.operation === 'GET' ? item._original_serials : '',
      visible: item => item.lotto && item._serials_available,
      validators: [
        'required',
        'serials',
        (field, value, item) => {
          if (!item._original_serials) return true

          // if PUT, serials has not to be already there
          if (item.operation === 'PUT') {
            const sub = helpers.subtractSerials(value, item._original_serials)
            const alreadyThere = helpers.subtractSerials(value, sub)
            if (!alreadyThere.length) return true
            return `Serials ${helpers.compatSerials(alreadyThere)} already there`
          }

          let ret = helpers.subtractSerials(value, item._original_serials)

          // ret = helpers.subtractSerials(value, ret)

          if (ret.length) {
            let notAvailable = helpers.compatSerials(ret)
            return `Serials ${notAvailable} not available`
          }
          return true
        }        
      ]
    },
    {
      value: 'serials',
      text: 'Serials',
      type: 'hidden',
      table: true,
      deps: ['_serials'],
      default: item => item._serials && helpers.compatSerials(helpers.explodeSerials(item._serials))
    },
  ],
  actions: ['remove']
}
